import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.93945 11.25L20.4395 11.25V12.75L1.93945 12.75V11.25Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.6289 15.9999L19.6289 11.9999L15.6289 7.99989L16.6896 6.93923L21.7502 11.9999L16.6896 17.0605L15.6289 15.9999Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol